<h2 mat-dialog-title>Ett fel uppstod</h2>
<mat-dialog-content>
  <p>Vänligen försök igen eller kontakta PP & IT om problemet kvarstår.</p>

  <div class="error-details">
    <p>{{ data.name }}</p>
    <p>{{ data.message }}</p>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton="elevated"
          [mat-dialog-close]="true">Stäng
  </button>
</mat-dialog-actions>